<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-also-by element-with-heading full-character-formatting" id="also-by">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-upper">ALSO BY TRICIA LEEDOM</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<p class="first first-in-chapter first-full-width also-by-content">The Key West Escape Series</p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://www.fireflyhillpress.com/rum-runner" target="_blank">Rum Runner - Book 1</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://www.fireflyhillpress.com/bahama-mama" target="_blank">Bahama Mama - Book 2</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://www.fireflyhillpress.com/passion-punch" target="_blank">Passion Punch - Book 3</a></p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width also-by-content">The Lost Souls’ Treasure Series</p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://www.fireflyhillpress.com/pieces-of-eight" target="_blank">Pieces of Eight - Book 1</a></p>
<p class="subsq also-by-content"><a class="content-external-link" href="https://www.fireflyhillpress.com/gentleman-of-fortune" target="_blank">Gentleman of Fortune - Book 2</a></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsobytricialeedom.vue?3c88f276